import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  jumping: false,
  bottom: null,
  height: null,
  left: null,
  right: null,
  top: null,
  width: null,
  x: null,
  y: null,
  size: 0,          // 0: small, 1: medium, 2: large
  speedBoost: false,
  lives: 3,
  invincible: false,
  invincibleTimer: null,
};

export const marioSlice = createSlice({
  name: "mario",
  initialState,
  reducers: {
    // Position and movement reducers
    marioJumping: (state, action) => {
      state.jumping = action.payload;
    },
    marioBottom: (state, action) => {
      state.bottom = action.payload;
    },
    marioHeight: (state, action) => {
      state.height = action.payload;
    },
    marioLeft: (state, action) => {
      state.left = action.payload;
    },
    marioRight: (state, action) => {
      state.right = action.payload;
    },
    marioTop: (state, action) => {
      state.top = action.payload;
    },
    marioWidth: (state, action) => {
      state.width = action.payload;
    },

    // Size management reducers
    setMarioSize: (state, action) => {
      state.size = action.payload;
    },
    increaseMarioSize: (state) => {
      if (state.size < 2) {
        state.size += 1;
      }
    },
    shrinkMarioSizeOnHit: (state) => {
      if (!state.invincible) {
        if (state.size > 0) {
          state.size -= 1;
          state.invincible = true;
        }
      }
    },
    resetMarioSize: (state) => {
      state.size = 0;
    },

    // Invincibility system
    setInvincible: (state, action) => {
      state.invincible = action.payload;
      if (!action.payload && state.invincibleTimer) {
        clearTimeout(state.invincibleTimer);
        state.invincibleTimer = null;
      }
    },
    setInvincibleTimer: (state, action) => {
      state.invincibleTimer = action.payload;
    },

    // Power-ups
    setSpeedBoost: (state, action) => {
      state.speedBoost = action.payload;
    },

    // Life system
    setLives: (state, action) => {
      state.lives = action.payload;
    },
    decrementLife: (state) => {
      if (state.lives > 0) {
        state.lives -= 1;
      }
    },
    incrementLife: (state) => {
      state.lives += 1;
    },
  },
});

// Export all actions
export const {
  marioJumping,
  marioBottom,
  marioHeight,
  marioLeft,
  marioRight,
  marioTop,
  marioWidth,
  setMarioSize,
  increaseMarioSize,
  shrinkMarioSizeOnHit,
  resetMarioSize,
  setInvincible,
  setInvincibleTimer,
  setSpeedBoost,
  setLives,
  decrementLife,
  incrementLife,
} = marioSlice.actions;

export default marioSlice.reducer;